/**
 * Shared sso function space
 *
 */
import { isWindows } from '../../shared/utils/is';
import { hideLoadingDialog, showErrorMessage } from '../../shared/utils/notifications';
import { Djangosaml2ClientAuth } from './djangosaml2ClientAuth';

export const getDjangosaml2ClientAuth = (idpEntityId, state) => {
    return new Djangosaml2ClientAuth({
        domain: process.env.API_URL,
        entityId: idpEntityId,
        state
    });
};

const performSSOLogin = async (idpEntityId, state) => {
    if (isWindows()) {
        return await getDjangosaml2ClientAuth(idpEntityId, state).authorizeWindows();
    } else {
        return await getDjangosaml2ClientAuth(idpEntityId, state).getDjangosaml2Response();
    }
};

export const authorizeDjangosaml2 = async (idpEntityId, state) => {
    // Complete the SSO authentication process - open a window, log into your IdP, get redirected to our back-end and then mobile code, and close the window
    const { error, token } = await performSSOLogin(idpEntityId, state);
    // Once the auth window is closed, pass the user JWT through the mobile client to the back-end to log into the mobile app.
    if (error) {
        if (isWindows()) {
            $f.mobile.redirect('zenput://logout');
        } else {
            // The above $f.mobile.redirect isn't working intermittently for android/ios, so using this instead.
            location.reload();
        }
        return;
    }
    $f.mobile.ajax({
        url: '/api/v3/sso/login_mobile/',
        dataType: 'json',
        type: 'POST',
        cache: false,
        data: JSON.stringify({ token }),
        success: $f.mobile.login,
        error: function (response = {}) {
            response = response || {};
            hideLoadingDialog();
            $('.login').show();
            $('.oauth-intermediary').hide();
            if (response.responseText != 'no-user-found') {
                return showErrorMessage(_t('mobile_oauth_generic_error_message'));
            }
            showErrorMessage(_t('mobile_oauth_no_user_error_message'), false, 20000);
        }
    });
};
